import errorIcon from "../assets/images/error404.svg";

export const Error404 = () => {
    return (
        <main id="error404">
          <section>
            <div className="inner_block">
            <h1><img src={errorIcon} /> Cтраница не найдена!</h1>
            </div>
          </section>
        </main>
    )
}

